import Paragraph from 'components/atoms/Paragraph';
import TranslateText from 'components/hoc/TranslateText';
import routePathEnum from 'enums/routePathEnum';
import React from 'react';
import { useHistory } from 'react-router-dom';

const PopisSluzby: React.FC = () => {
    const history = useHistory();

    return (
        <>
            <h1
                style={{
                    color: '#006866',
                    fontWeight: 600,
                    marginTop: 10
                }}
                id="top"
            >
                <TranslateText>POPIS_SLUBY_TITLE</TranslateText>
            </h1>
            <Paragraph text="POPIS_SLUBY_TEXT" />

            <div
                style={{
                    display: 'block',
                    textDecoration: 'underline',
                    marginTop: 6
                }}
            >
                <a onClick={() => history.push(routePathEnum.LEI_PREHLED_UCTU)}>
                    <TranslateText>SLUZBA_ODKAZ</TranslateText>
                </a>
            </div>
        </>
    );
};

export default PopisSluzby;
